import {ProductSectionPropsGenqlSelection} from "@/gql/gen";

export const ProductSectionPropsFields: ProductSectionPropsGenqlSelection = {
    MENU_ITEM_STYLE: true,
    MENU_COLOR: true,
    MENU_ICON: {
        SRC: true
    },
    MENU_FOCUSED_ICON: {
        SRC: true
    },
    MODIFICATORS: true
}
